export function isAnimatedGif(src: string): boolean {
  return /\.gif(?:[?#]|$)/i.test(src);
}

export function isVideo(src: string): boolean {
  return /\.(?:mp4|webm)(?:[?#]|$)/i.test(src);
}
